import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/home/home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/agriculturalPlan',
    name: `agriculturalPlan`,
    meta: {
      title: '农事方案',
    },
    component: () => import('@/views/agriculturalPlan/index'),
  },
  {
    path: '/agriculturalMachinery',
    name: `agriculturalMachinery`,
    meta: {
      title: '农机调度',
    },
    component: () => import('@/views/agriculturalMachinery/index'),
  },
  {
    path: '/deviceDetection',
    name: `deviceDetection`,
    meta: {
      title: '设备检测',
    },
    component: () => import('@/views/deviceDetection/index'),
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
